import React from 'react';
import { StyledTableContent, StyledTableHeader } from '../../table/StyledTable';
import { IPageData } from 'types/rest/IPageData';
import { Grid, PageLoading } from 'ui-toolkit';
import { StyledTableRow, StyledTableHeaderValue } from './MatchedActualStyles';
import { IEscrowActualIncomingWireQuery } from 'types/accounting/query/IEscrowActualIncomingWireQuery';
import { IEscrowActualIncomingWireData } from 'types/accounting/data/IEscrowActualIncomingWireData';
import { MatchActualWireDepositRow } from './MatchActualWireDepositRow';
import { MatchActualWireDepositSearchBar } from './MatchActualWireDepositSearchBar';
import { Pager } from 'ui-toolkit/components/DataGrid/tabbedTable/BottomPager';

interface IMatchActualWireDepositTableProps {
  data: IPageData<IEscrowActualIncomingWireData>;
  isQueryFetching: boolean;
  query: IEscrowActualIncomingWireQuery;
  selectedId?: string;
  setSelectedId: (detail: string | undefined) => void;
  setQuery: (query: IEscrowActualIncomingWireQuery) => void;
}

export const MatchActualWireDepositTable: React.FC<IMatchActualWireDepositTableProps> = ({
  query,
  data,
  isQueryFetching,
  selectedId,
  setSelectedId,
  setQuery,
}) => {
  const columns = ['Completed At Date', 'OBI', 'Sender', 'Received', 'Unmatched', 'Selected'];

  const onPageChange = (newPage: number) => {
    setQuery({ ...query, pageNumber: newPage });
  };
  const onPageSizeChange = (newPageSize: number) => {
    setQuery({ ...query, pageSize: newPageSize });
  };

  return (
    <>
      <Grid rowGap={'baseUnit'}>
        <MatchActualWireDepositSearchBar setQuery={setQuery} query={query} />
        <StyledTableHeader>
          <StyledTableRow columnsLength={columns.length}>
            {columns.map((t) => (
              <StyledTableHeaderValue key={t}>{t}</StyledTableHeaderValue>
            ))}
          </StyledTableRow>
        </StyledTableHeader>
        <PageLoading isLoading={isQueryFetching}>
          <StyledTableContent className={'pb-4'}>
            {data?.content?.map((item) => (
              <MatchActualWireDepositRow
                wireDeposit={item}
                key={item.id}
                selectedId={selectedId}
                setSelectedId={setSelectedId}
              />
            ))}
          </StyledTableContent>
          <Pager
            total={data.totalElements}
            page={data.pageNumber}
            pageSize={data.pageSize}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
          />
        </PageLoading>
      </Grid>
    </>
  );
};
